<template>

    <div>

        <!-- page-heading -->
        <page-heading :show="true" pageTitle="IP-HEADLINE"></page-heading>

        <!-- show loading indicator -->
        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

            <div class="columns">

                <div class="col-main">

                    <div class="box">

                        <div class="form-centered">

                            <div class="control">

                                <div class="control-label"></div>

                                <div class="control">

                                    <div class="columns is-12" style="width: 100%; margin: 0; background: #f5f7f9; border-radius: 3px;">

                                        <div class="column is-5">
                                            <lightbox :src="getImagePath(image)" :caption="stripHTML(image.caption)" class="has-pointer">
                                                <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImagePath(image)"></div>
                                            </lightbox>
                                        </div>

                                        <div class="column">

                                            <div class="imageInfo">
                                                <div><span>Dateigröße:</span>{{ formatBytes(image.filesize) }}</div>
                                                <div><span>Abmessungen:</span>{{ imageDimensions }}</div>
                                                <div><span>Dateiname:</span>{{ image.filename }}</div>
                                                <div><span>Dateiformat:</span>{{ getFileFormat(image) }}</div><br />
                                                <div><span>hochgeladen von:</span>{{ image.createdBy.username }}</div>
                                                <div><span>hochgeladen am:</span>{{ formatDate(image.created) }}</div>
                                            </div>

                                            <a :href="getImagePath(image)" download class="downloadLink">
                                                <span class="icon is-small">
                                                    <i class="icon-ak-download"></i>
                                                </span> Bild herunterladen
                                            </a>

                                        </div>


                                    </div>
                                </div>

                            </div>


                            <div v-if="image.path == 'mediaArchive' && imageDataMetaInfo.length > 0" class="metaInfo">

                                <div v-for="meta in imageDataMetaInfo">
                                    <lang :labelKey="'ASSET_META_'+meta.name"></lang>
                                    <span>{{ meta.value }}</span>
                                </div>

                            </div>

                            <!-- status -->
                            <form-input inputType="select" label="IPI-STATUS" v-model="image.status" :selectOptions="assetStatus" :selectIsDisabled="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1"></form-input>

                        </div>

                        <!-- status bar -->
                        <div :class="['statusBlock', image.status != null ? image.status.name : '']"></div>

                        <div class="form-centered">

                            <div class="control">

                                <div class="control-label">
                                    <label-name labelKey="IP-ARTICLES"></label-name>
                                </div>

                                <div class="control">

                                    <multiselect
                                        v-model="assetArticles"
                                        :options="selectOptions"
                                        label="title"
                                        deselect-label="Klick um abzuwählen"
                                        selectLabel="Klick um auszuwählen"
                                        selectedLabel="ausgewählt"
                                        :customLabel="customLabel"
                                        :placeholder="$t('SELECT_BOX-IP-ARTICLES-PLEASE_SELECT')"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="false"
                                        :disabled="['Herba Vorstand', 'Agentur Layouter'].indexOf(activeUser.userRole.name) > -1"
                                        track-by="article"
                                        class="singleSelect">

                                    </multiselect>

                                </div>
                            </div>

                            <!-- caption -->
                            <div class="control">
    							<div class="control-label">
    					            <label-name labelKey="IPI-CAPTION"></label-name>
    					        </div>
    							<div class="control froalaPlain">
    								<froala :tag="'textarea'" :config="froalaConfig" v-model="image.caption"></froala>
    							</div>
    						</div>

                            <!-- alternative title -->
                            <form-input inputType="text" label="IPI-ALT_TEXT" v-model="image.altText" :isReadOnly="['Herba Vorstand', 'Agentur Layouter'].indexOf(activeUser.userRole.name) > -1"></form-input>

                            <!-- source / origin -->
                            <form-input inputType="text" label="IPI-ORIGIN" v-model="image.origin" :isReadOnly="['Herba Vorstand', 'Agentur Layouter'].indexOf(activeUser.userRole.name) > -1"></form-input>

                            <template v-for="(value, index) in imageData" v-if="imageData != null">

                                <!-- restriction -->
                                <div class="control" v-if="value == 'restrictFacebook'">
                                    <div class="control-label">
                                        <label-name :labelKey="'IPI-'+value"></label-name>
                                    </div>
                                    <div class="control">
                                        <b-switch v-model="image.data[value]" type="primary" class="is-small" :disabled="['Herba Vorstand', 'Agentur Layout'].indexOf(activeUser.userRole.name) > -1"></b-switch>
                                    </div>
                                </div>

                            </template>

                            <!-- source / origin -->
                            <form-input inputType="text" label="IPI-TAGS" v-model="image.tags" :isReadOnly="['Herba Vorstand', 'Agentur Layouter'].indexOf(activeUser.userRole.name) > -1"></form-input>

                        </div>

                    </div>

                    <!-- COMMENTS -->
				            <comments :threadID.sync="image.thread" :api="'asset/'+image.id"></comments>


                </div>

                <div class="col-aside">

            			<affix :offset="50">

        					<custom-button type="blue" name="IPI-BTN-SAVE" icon="icon-ak-speichern" :loading="isSaving" @click.native="save"></custom-button>

                  <router-link :to="{ name: 'complatImagePoolImageChangelog' }" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
                      <custom-button type="dark" name="IPI-BTN-CHANGELOG" icon="icon-ak-history"></custom-button>
                  </router-link>

          			</affix>

          		</div>

            </div>

        </template>

    </div>

</template>


<script>
import comments from '../../utils/incl-comments';
// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
// require('froala-editor/css/froala_style.min.css')

import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)

export default {

    components: {
        comments
    },

    data() {

        var self = this;

        return {
            isLoading: false,
            isSaving: false,
            image: null,
            assetArticles: [],
            imageData: [],
            imageDimensions: null,
            articles: [],
            // tags: [],
            froalaConfig: {
                editor: 'off',
                enter: $.FroalaEditor.ENTER_BR,
                key: '',
                toolbarButtons: ['bold', 'italic', 'underline', '|', 'subscript', 'superscript'],
                // toolbarButtons: ['bold', 'italic', 'underline', '|', 'color', '|', 'subscript', 'superscript', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertTable', '|', 'insertImage', '|', 'undo', 'redo', '|', 'myDropdown'],
                placeholderText: 'Schreiben Sie hier Ihren Text ...',
                pastePlain: true,
                initOnClick: false,
                heightMin: 100,
                heightMax: 200,
                quickInsertButtons: [],
                quickInsertTags: [],
                language: 'de',
                charCounterCount: false,
                // charCounterMax: 140,
                events: {
			             'froalaEditor.initialized': function(e, editor) {
                    if(['Herba Vorstand', 'Agentur Layouter'].indexOf(self.activeUser.userRole.name) > -1) {
                        editor.edit.off();
                    }
                },
	            }
            },
        }
    },

    computed: {

        imageDataMetaInfo() {

            let meta = [];
            for(var key in this.image.data) {

                if(['year', 'betrieb', 'abteilung', 'persons', 'anlass'].indexOf(key) > -1) {

                    meta.push({
                        name: key,
                        value: this.image.data[key]
                    })

                }

            }

            return meta;

        },

    		assetStatus() {
    			return this.$store.getters.getTermsByTaxonomy('ASSET_STATUS');
    		},

        selectOptions() {

            return this.articles;

            var options = [];
            this.articles.forEach((article) => {

                if(article.asset != null) {

                    let obj = {
                        id: article.asset.id,
                        isDefault: article.asset.isDefault,
                        asset: article.asset.asset.id.toString(),
                        article: {
                            id: article.id,
                            title: article.title,
                            updated: article.updated,
                            created: article.created,
                            type: article.type,
                            createdBy: article.createdBy.id,
                            publications: article.publications,
                            asset: article.asset,
                            categories: article.categories
                        }
                    }

                    options.push(obj);
                }

            })

            return options;
        }

    },

    created() {

        // froala licence
        this.froalaConfig.key = this.$config.froalaKey;

        if(this.$route.name == 'complatImagePoolNew') {
            this.fetchArticles();
        } else {
            this.fetchData();
        }

	},


	mounted() {

	},

    methods: {


        customLabel ({ title, desc }) {

            return title;

        },

        /*
        tagAdd(newTag) {

    		let tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }

    		this.tags.push(tag);

            if(this.image.tags == null) {
                this.image.tags = [];
            }
    		this.image.tags.push(tag);


            console.log("tagOptions: ", this.tags);
            console.log("imageTags: ", this.image.tags);
        },

        tagSelect() {


        },
        */

        formatBytes(a,b) {

            if(0==a)return"0 Bytes";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]

        },

        getFileFormat(asset) {

            return '.' + asset.filename.split('.').pop();

        },

        getImagePath(asset) {

        	return this.$config.assets + asset.path + '/' + asset.filename;

        },

        fetchData() {

            this.isLoading = true;
            var self = this;

            // get asset
            function getAsset() {
                return self.axios.get(self.$config.api + 'asset/' + self.$route.params.imageID + '/imagePool');
            }

            // get articles
            function getArticles() {
                return self.axios.get(self.$config.api + 'article?loadChangesLog=0');
            }



            // make the request
            this.axios.all([getAsset(), getArticles()])
                .then(self.axios.spread(function (asset, articles) {


                    articles.data.article.forEach((article) => {
                        self.articles.push({
                            article: article.id,
                            title: article.title
                        })
                    })

                    asset.data.articles.forEach((article, index) => {
                        self.assetArticles.push({
                            id: article.id,
                            article: article.article.id,
                            title: article.article.title
                        })
                    })


                    self.image = asset.data;

                    // get image dimensions
                    let img = new Image;
                    img.onload = function() {
                        self.imageDimensions = img.width + 'px x ' + img.height + 'px';
                    };

                    img.src = self.getImagePath(self.image);


                    if(asset.data.data != null) {

						let k;
						for (k of Object.keys(asset.data.data)) {
							self.imageData.push(k);
						}

					}

                    self.isLoading = false;

                }));


        },




        fetchArticles() {

            this.isLoading = true;
            var self = this;

            this.axios.get(self.$config.api + 'article?loadChangesLog=0')
                .then(function(response) {

                    self.articles = articles.data.article;
                    self.isLoading = false;

                });

        },


        /*
        fetchData() {

            this.isLoading = true;

            var self = this;

            this.axios.get(this.$config.api + 'asset/'+this.$route.params.imageID+'/imagePool')
                .then(function(response) {

                    self.isLoading = false;
                    self.image = response.data;

                    // get image dimensions
                    let img = new Image;
                    img.onload = function() {
                        self.imageDimensions = img.width + 'px x ' + img.height + 'px';
                    };

                    img.src = self.getImagePath(self.image);


                    if(response.data.data != null) {

						let k;
						for (k of Object.keys(response.data.data)) {
							self.imageData.push(k);
						}

					}

                    // console.log(response.data.status);
                });

        },
        */


        save() {

            this.isSaving = true;
            var self = this;


            this.entityCreateOrUpdate('asset', this.image, { isSilent: false })
                .then(function(response) {

                    if(self.assetArticles.length > 0) {

                        // prepare our articleAssetsArr (needed for the update into the assetsArticle table)
                        var assetArticlesArr = {
                            assets: [],
                            articles: []
                        }

                        assetArticlesArr.assets.push(self.$route.params.imageID);

                        self.assetArticles.forEach(function(article) {
                            if(article.article) {
                                assetArticlesArr.articles.push(article.article);
                            }
                        })


                        // save in articleAssets
                        self.axios.put(self.$config.api + 'articleAsset/updateArticleReferences', assetArticlesArr)
                            .then(function(response) {
                                self.isSaving = false;
                            });

                    }


                });

        }



    }


}
</script>


<style scoped>

    .form-centered {
        margin: 0 auto;
        max-width: 640px;
    }
    .form-centered .control {
        max-width: 640px;
    }
    .form-centered >>> .control > .control {
        max-width: 100% !important;
    }
    .statusBlock {
		width: auto;
		padding: 0;
		margin: 20px -25px;
		background: #F5F5F5;
		background: none;
		transition: border .3s ease;
		border-bottom: 15px solid #FFF;
	}
	.statusBlock.DEFAULT {
		border-bottom-color: #CDCDD2;
	}
	.statusBlock.DEF {
		border-bottom-color: #76d8db;
	}
	.statusBlock.APPROVED {
        border-bottom-color: #bfe29e;
	}


    .column .imageInfo {
        font-size: 11px;
        margin-bottom: 25px;
    }
    .column .imageInfo span {
        font-weight: bold;
        display: inline-block;
        min-width: 100px;
    }
    .column .downloadLink {
        font-size: 12px;
        display: flex;
        align-items: center;
    }
    .column .downloadLink .icon {
        margin-right: 5px;
    }
    .imgWrapper {
        background-repeat: no-repeat;
        background-position: 50% 50% !important;
        background-size: contain;
        width: 100%;
        height: 120px;
        height: 0;
        padding-bottom: 66%;
        margin: 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }
    .imgWrapper[lazy=loading]  {
        background-size: 30% !important;
    }
    .imgWrapper[lazy=error]  {
        background-image: none !important;
    }

    .metaInfo {
        width: 100%;
        margin: 0px 0px 15px;
        background: rgb(245, 247, 249);
        border-radius: 3px;
        padding: 10px;
        font-size: 11px;
    }

    .metaInfo span:first-child {
        display: inline-block;
        width: 120px;
        font-weight: bold;
    }
</style>
